"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const SvgComponent = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 32 32",
  fill: "none",
  role: "img"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.12 21.92a.73.73 0 00-.34.62v1.73c0 .57.62.92 1.1.62l3.01-1.82-2.16-2.19-1.61 1.04zM27.92 13l-2.54-1.58c0-.64-.1-1.4-.32-2.22-.5-1.93-1.44-3.36-2.06-3.2-.64.18-.74 1.88-.23 3.8l.1.33a8.02 8.02 0 00-.74-.83c-1.4-1.42-2.9-2.18-3.37-1.71-.46.47.3 2 1.69 3.41a8.94 8.94 0 001.69 1.36 2.77 2.77 0 00-.35 1.3C19.46 12 14.81 8.93 11.67 8.93a5.76 5.76 0 00-4.73 2.47c-.08-.12-.13-.25-.24-.36a2.15 2.15 0 00-3.07 0 2.21 2.21 0 000 3.1c.74.75 1.87.8 2.7.24l8.65 8.74c.27.27.64.43 1.02.43h6.5c.4 0 .72-.33.72-.73v-.73c0-.81-.64-1.46-1.44-1.46h-4.34v-2.54a3.66 3.66 0 00-2.61-3.52l-1.92-.55a.73.73 0 01-.5-.9c.12-.4.52-.61.9-.5l1.91.55a5.13 5.13 0 013.67 4.92v1.07l2.89-1.46h4.66a2.57 2.57 0 002.28-3.77 2.58 2.58 0 00-.8-.92zm-2.53 1.77a.73.73 0 01-.72-.73.72.72 0 111.44 0c0 .4-.32.73-.72.73z",
  fill: "currentColor"
}));
var _default = exports.default = SvgComponent;